// HomeWeb.jsx
import React, { useState, useRef } from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform, TouchableWithoutFeedback, TextInput, KeyboardAvoidingView, Alert } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from '../../components/baseWeb';
import styles from '../../styles/formularios';
import axios from 'axios';
import MaskInput, { Masks } from 'react-native-mask-input'; // Para aplicar máscara no CPF
export default function DadosDoImovelContratoCorretagemWeb({ route }) {
    const { id = null, analise_id } = route?.params || {};
    console.log("ID ANALISE:", analise_id)
    console.log("ID ANALISE (id):", id)
    const navigation = useNavigation();
    // envio unico 

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [usuario_id, setUsuario_id] = useState(null);

    // Referências para os inputs
    const cepInputRef = useRef(null);
    const enderecoInputRef = useRef(null);
    const complementoInputRef = useRef(null);
    const bairroInputRef = useRef(null);
    const cidadeUfInputRef = useRef(null);
    const IptuInputRef = useRef(null);
    const CartorioInputRef = useRef(null);
    const MatInputRef = useRef(null);
    const CorretagemInputRef = useRef(null);
    // Estado dos campos
    const [cep, setCep] = useState('');
    const [endereco, setEndereco] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidadeUf, setCidadeUf] = useState('');
    const [complemento, setComplemento] = useState('');
    const [iptu, setIptu] = useState('');
    const [cartorio, setCartorio] = useState('');
    const [mat, setMat] = useState('');
    const [imovelData, setImovelData] = useState(null);
    const [valorVendaImovel, setValorVendaImovel] = useState('');

    const [corretagem, setCorretagem] = useState('');

    const formatNumer = (value) => {
        if (!value) return '';

        // Remove tudo o que não for número
        const numericValue = value.replace(/[^0-9]/g, '');

        return numericValue
    }

    const formatCurrency = (value) => {
        if (!value) return '';

        // Remove tudo o que não for número
        const numericValue = value.replace(/[^0-9]/g, '');

        // Converte para número e formata com casas decimais
        const formattedValue = (numericValue / 100).toFixed(2).replace('.', ',');

        // Insere o ponto a cada três dígitos (se necessário)
        return 'R$ ' + formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };
    // Máscara para o CEP
    const handleCepChange = (text) => {
        const formattedCep = text.replace(/\D/g, '').replace(/(\d{5})(\d{3})/, '$1-$2');
        setCep(formattedCep);
        if (formattedCep.length === 9) {
            buscaCep(formattedCep);
        }
    };

    // Busca endereço pelo CEP
    const buscaCep = async (cep) => {
        try {
            const response = await axios.get(`https://viacep.com.br/ws/${cep.replace('-', '')}/json/`);
            if (response.data) {
                setEndereco(response.data.logradouro);
                setBairro(response.data.bairro);
                setCidadeUf(`${response.data.localidade}/${response.data.uf}`);
            }
        } catch (error) {
            Alert.alert('Erro', 'Não foi possível buscar o CEP');
        }
    };

    // Validação para habilitar o botão "Salvar"
    const isFormValid = () => cep && endereco && bairro && cidadeUf && valorVendaImovel && corretagem;

    const handleSaveImovel = async () => {
        if (!isFormValid()) {
            Alert.alert('Erro', 'Preencha todos os campos obrigatórios.');
            return;
        }

        setIsSubmitting(true); // Inicia a submissão

        const formattedCorretagem = parseFloat(corretagem.replace(',', '.'));
        const formattedValorVenda = parseFloat(valorVendaImovel.replace('R$ ', '').replace('.', '').replace(',', '.'));
        const enderecoFull = `${endereco} ${complemento}, ${bairro}- ${cidadeUf}`;

        navigation.navigate('EtapasCorretagemWeb', { status: 2, endereco_imovel: enderecoFull, valor_de_venda: formattedValorVenda, percentual_corretagem: formattedCorretagem });
    };

    return (
        <BaseWeb>
            {(userInfo) => {
                setUsuario_id(userInfo.id)
                return (
                    <ScrollView contentContainerStyle={styles.contentMinimal}>
                        <View style={styles.formContainer}>
                            <Text style={styles.title}>Dados do imóvel</Text>

                            <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>CEP *</Text>
                                <TouchableWithoutFeedback onPress={() => cepInputRef.current.focus()}>
                                    <View style={styles.inputContainer}>
                                        <TextInput
                                            ref={cepInputRef}
                                            allowFontScaling={false}
                                            style={styles.areaInput}
                                            placeholder="00000-000"
                                            placeholderTextColor="#A9A9A9"
                                            value={cep}
                                            onChangeText={handleCepChange}
                                            keyboardType="numeric"
                                            maxLength={9}
                                        />
                                    </View>
                                </TouchableWithoutFeedback>
                            </View>

                            {/* Endereço */}
                            <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Endereço *</Text>
                                <TouchableWithoutFeedback onPress={() => enderecoInputRef.current.focus()}>
                                    <View style={styles.inputContainer}>
                                        <TextInput
                                            ref={enderecoInputRef}
                                            allowFontScaling={false}
                                            style={styles.areaInput}
                                            placeholder="Rua, Avenida..."
                                            placeholderTextColor="#A9A9A9"
                                            value={endereco}
                                            onChangeText={setEndereco}
                                        />
                                    </View>
                                </TouchableWithoutFeedback>
                            </View>

                            {/* Complemento */}
                            <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Complemento (opcional)</Text>
                                <TouchableWithoutFeedback onPress={() => complementoInputRef.current.focus()}>
                                    <View style={styles.inputContainer}>
                                        <TextInput
                                            ref={complementoInputRef}
                                            allowFontScaling={false}
                                            style={styles.areaInput}
                                            placeholder="Apto, Bloco..."
                                            placeholderTextColor="#A9A9A9"
                                            value={complemento}
                                            onChangeText={setComplemento}
                                        />
                                    </View>
                                </TouchableWithoutFeedback>
                            </View>

                            {/* Bairro */}
                            <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Bairro *</Text>
                                <TouchableWithoutFeedback onPress={() => bairroInputRef.current.focus()}>
                                    <View style={styles.inputContainer}>
                                        <TextInput
                                            ref={bairroInputRef}
                                            allowFontScaling={false}
                                            style={styles.areaInput}
                                            placeholderTextColor="#A9A9A9"
                                            placeholder="Bairro"
                                            value={bairro}
                                            onChangeText={setBairro}
                                        />
                                    </View>
                                </TouchableWithoutFeedback>
                            </View>

                            {/* Cidade e UF */}
                            <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Cidade/UF *</Text>
                                <TouchableWithoutFeedback onPress={() => cidadeUfInputRef.current.focus()}>
                                    <View style={styles.inputContainer}>
                                        <TextInput
                                            placeholderTextColor="#A9A9A9"
                                            ref={cidadeUfInputRef}
                                            allowFontScaling={false}
                                            style={styles.areaInput}
                                            placeholder="Cidade/UF"
                                            value={cidadeUf}
                                            onChangeText={setCidadeUf}
                                        />
                                    </View>
                                </TouchableWithoutFeedback>
                            </View>

                            {/* Separador visual (Divisão) */}
                            <View style={styles.divider} />
                            <View style={styles.row}>
                                <Text style={styles.subTitulo} allowFontScaling={false}>Informações adicionais</Text>
                                <Text style={styles.subLabel} allowFontScaling={false}>Valor de venda do imovel  *</Text>
                                <TouchableWithoutFeedback onPress={() => MatInputRef.current.focus()}>
                                    <View style={styles.inputContainer}>
                                        <TextInput
                                            style={styles.areaInput}
                                            placeholder="R$"
                                            value={valorVendaImovel}
                                            onChangeText={(text) => setValorVendaImovel(formatCurrency(text))}
                                            keyboardType="numeric"
                                            allowFontScaling={false}
                                            placeholderTextColor="#A9A9A9"
                                            pointerEvents="auto"
                                        />
                                    </View>
                                </TouchableWithoutFeedback>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Percentual de corretagem (%)*</Text>
                                <TouchableWithoutFeedback onPress={() => CorretagemInputRef.current.focus()}>
                                    <View style={styles.inputContainer}>
                                        <TextInput
                                            ref={CorretagemInputRef}
                                            allowFontScaling={false}
                                            style={styles.areaInput}
                                            placeholder="Ex: 5"
                                            keyboardType="numeric"
                                            placeholderTextColor="#A9A9A9"
                                            value={corretagem}
                                            onChangeText={(text) => setCorretagem(formatNumer(text))}
                                        />
                                    </View>
                                </TouchableWithoutFeedback>
                            </View>

                            {/* Botão Salvar */}
                            <View style={styles.buttonContainer}>
                                <TouchableOpacity
                                    style={[
                                        styles.saveButton,
                                        (!isFormValid() || isSubmitting) && { backgroundColor: '#ccc' },
                                    ]}
                                    onPress={handleSaveImovel}
                                    disabled={!isFormValid() || isSubmitting} // Desabilita durante a submissão
                                >
                                    <Text style={styles.saveButtonText} allowFontScaling={false}>
                                        {isSubmitting ? "Enviando..." : "Salvar"}
                                    </Text>
                                </TouchableOpacity>

                                <TouchableOpacity style={styles.laterButton}>
                                    <Image
                                        source={require('../../../assets/icons/bookmark.png')} // Ícone de terminar mais tarde
                                        style={styles.laterIcon}
                                    />
                                    <Text
                                        style={styles.laterButtonText}
                                        allowFontScaling={false}
                                        onPress={() => navigation.navigate('Home', { usuario_id })}
                                    >
                                        Terminar mais tarde
                                    </Text>
                                </TouchableOpacity>
                            </View>

                        </View>
                    </ScrollView>
                );
            }}
        </BaseWeb>
    );
}
